const COOKIE_MAX_AGE_DAYS = 365;
const COOKIE_NAME_PREFIX = "instructd_visit_";

function getCookieName(journeyId: string, environmentId: string): string {
  return `${COOKIE_NAME_PREFIX}${journeyId}_${environmentId}`;
}

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name: string, value: string, maxAgeDays: number): void {
  const maxAge = maxAgeDays * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
}

export function trackLandingIfFirstVisit(): void {
  const ctx = (window as unknown as { __GA_CONTEXT__?: { journeyId: string; organisationId: string; environmentId: string } }).__GA_CONTEXT__;
  if (!ctx?.journeyId || !ctx.environmentId) return;

  const cookieName = getCookieName(ctx.journeyId, ctx.environmentId);
  if (getCookie(cookieName)) return;

  fetch("/api/track-landing", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ journeyId: ctx.journeyId }),
  }).finally(() => {
    setCookie(cookieName, "1", COOKIE_MAX_AGE_DAYS);
  });
}
